export const Cancel = Symbol("Cancel");
export type Cancel = typeof Cancel;
